module.exports = __webpack_public_path__ + "img/verifikasi-web-icon-2.f50a0513.svg";